import { TimingTypeEnum } from '../../types/campaignsApiResponse.d';

export function getScrollPercent() {
	const { documentElement, body } = document;
	const { clientHeight } = documentElement;
	const st = 'scrollTop';
	const sh = 'scrollHeight';
	const top = documentElement[st] || body[st];
	const height = (documentElement[sh] || body[sh]) - clientHeight;
	const percentage = height === 0 ? 0 : (top / height) * 100;

	return Math.round(percentage);
}

export function canUseScrollDown(
	timingType: TimingTypeEnum,
	activate: number
): boolean {
	return timingType === TimingTypeEnum.SCROLL && activate !== 0;
}
